// METHODS

function scrollOnVisibilityAnimate(callback, el, threshold = 0.5) {
  let observer = new IntersectionObserver(
    (entry) => {
      if (entry?.[0]?.isIntersecting) {
        callback();
        observer.unobserve(el);
      }
    },
    {
      rootMargin: "0px",
      threshold,
    }
  );

  observer.observe(el);
}

function scrollCallbackForBG(AnimationInstance, elClass, divideRatio = 800) {
  let el = $(elClass);
  return () => {
    let scrollOffset = window.pageYOffset || window.scrollTop;
    let elOffset = el.offset().top - window.innerHeight;

    let readyScroll = scrollOffset - elOffset;
    if (readyScroll > 0) {
      let scrollDivided = readyScroll / (divideRatio + window.innerHeight);
      AnimationInstance.seek(AnimationInstance.duration * scrollDivided);
    }
  };
}

// INIT CALLBACK SCOPE

$(() => {
  new LazyLoad({
    use_native: true,
  });

  setContactListener();

  anime({
    targets: ".case-study",
    opacity: ["0%", "100%"],
    translateY: ["40px", "0"],
    easing: "easeInOutQuad",
    duration: 800,
    delay: anime.stagger(400),
  });

  // HERO animations
  anime({
    targets: ".onload-animate-in",
    opacity: ["0%", "100%"],
    translateY: ["-10px", "0"],
    easing: "easeInOutQuad",
    duration: 600,
    delay: anime.stagger(200, { start: 100 }),
  });
  // BG animations

  let scrollCallbackFooterNet = scrollCallbackForBG(
    anime({
      targets: ".bg-graphic--footer img",
      translateY: 120,
      autoplay: false,
      easing: "linear",
    }),
    ".navigation-footer",
    window.innerHeight
  );

  scrollCallbackFooterNet();

  $(window).on(
    "scroll",
    requestAnimationFrame.bind(null, () => {
      scrollCallbackFooterNet();
    })
  );

  // Filtering functionality

  let activeServicesList = new Set(
    window.location.hash.replace("#", "")
      ? window.location.hash.replace("#", "").split(",")
      : []
  );

  $(".service-tag").on("click", (e) => {
    let key = e.target.dataset.key;

    if (activeServicesList.has(key)) {
      activeServicesList.delete(key);
    } else {
      activeServicesList.add(key);
    }

    checkActiveServices();
    checkActiveCSs();

    window.location.hash = [...activeServicesList].join(",");
  });

  checkActiveServices();
  checkActiveCSs();

  function checkActiveServices() {
    $(".service-tag").each((el) => {
      let key = el.dataset.key;
      $(el).removeClass("active");

      if (activeServicesList.has(key)) {
        $(el).addClass("active");
      }
    });
  }
  function checkActiveCSs() {
    let activeServices = [...activeServicesList];
    $(".case-study").each((el) => {
      let keys = el.dataset.services?.trim()?.split(" ");
      $(el).removeClass("hidden");

      let isActive =
        activeServices.filter((val) => keys.includes(val)).length > 0;

      if (!isActive && activeServices.length !== 0) {
        $(el).addClass("hidden");
      }
    });
  }
});
